// src/utils/pricing.js
export const basePi = (p, piToUsdRate) => {
  if (p?.pricingType === 'dynamic' && piToUsdRate && p?.usdPrice != null) {
    return +(p.usdPrice / piToUsdRate).toFixed(2);
  }
  return +Number(p?.price || 0).toFixed(2);
};

export const saleViewFor = (p, piToUsdRate) => {
  // Prefer server-enriched pricingView
  const pv = p?.pricingView;
  if (pv?.isOnFlashSale && pv?.basePrice != null && pv?.effectivePrice != null) {
    const original = +Number(pv.basePrice).toFixed(2);
    const discounted = +Number(pv.effectivePrice).toFixed(2);
    const percent = Math.max(0, Math.round((1 - discounted / Math.max(original, 0.000001)) * 100));
    return { original, discounted, percent, endsAt: pv.saleEndsAt || null };
  }

  // Fallbacks
  const original = basePi(p, piToUsdRate);
  const rawSalePrice = p?.pricing?.salePrice ?? p?.salePrice ?? null;
  const rawPercent   = p?.pricing?.salePercentOff ?? p?.salePercentOff ?? null;

  if (rawSalePrice != null) {
    const discounted = +Number(rawSalePrice).toFixed(2);
    const percent = rawPercent != null
      ? +Number(rawPercent)
      : Math.max(0, Math.round((1 - discounted / Math.max(original, 0.000001)) * 100));
    if (discounted < original) return { original, discounted, percent };
  }

  if (rawPercent != null) {
    const percent = +Number(rawPercent);
    if (Number.isFinite(percent) && percent > 0) {
      const discounted = +Number(original * (1 - percent / 100)).toFixed(2);
      return { original, discounted, percent };
    }
  }
  return null;
};
